import React from 'react';
import img from '../img/image.png'
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useState, useEffect } from 'react';
import { fetchNewsById } from '../strapi';
import Markdown from 'react-markdown';
import AliceCarousel from 'react-alice-carousel';
import { useParams } from 'react-router-dom'; // Add this import
import Box from '@mui/material/Box';

function NewsPage({ locale }) {
    const { id } = useParams(); // Get id from URL
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    const [newsPage, setNews] = useState({});
    const [imgSrc, setImgSrc] = useState(img);
    useEffect(() => {
        const element = document.getElementById("top");
        element.scrollIntoView({ behavior: "instant", block: "start" });
        if (!id) return;
        fetchNewsById(id, locale)
            .then(data => {
                setNews(data);
            })
            .catch(err => {
            });
    }, [id, locale]);
    return (
        <div >
            <Container id="top">
                <Typography className='titleOfPage' component="div" sx={{ mt: { xs: '', lg: '30px' }, pt: { xs: '80px', xl: '30px' } }}>
                    {newsPage.title}
                </Typography>
                <img alt='img' src={newsPage?.mainImg ? API_URL + newsPage.mainImg.url : img} onError={() => setImgSrc(img)}  style={{ width: '100%', maxWidth: 400, maxHeight: '100%', objectFit: 'contain' }}></img>
                <Typography gutterBottom variant="body1" component="div" className='date'>
                    {newsPage.date}
                </Typography>
                <Typography className='mainText' >
                    <Markdown>{newsPage.mainText}</Markdown>
                </Typography>
                
                    <AliceCarousel controlsStrategy="responsive" responsive={{
                       
                    }}>
                        {newsPage?.images && newsPage.images.map((item, index) => 
                        <Box display="flex" justifyContent="center" alignItems="center" p={1}>
                            <img 
                                alt='img'
                                src={API_URL + item.url}
                                style={{ width: '100%', maxWidth: 400, maxHeight: '100%', objectFit: 'contain' }}
                                className="news-carousel-img"
                            />
                        </Box>
                       
                    )}
                    </AliceCarousel>
                
            </Container>
        </div>
    );
}

export default NewsPage;